import * as _ from 'underscore';

import { Users } from '../../../ts/resources/Users';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { spaceContentsUpdateOwners, UpdateOwnerData } from '../../actions/spaces/RequestSpaceContentsActions';
import { appStore } from '../../AppStore';
import { ServiceLocator } from '../../ServiceLocator';
import { ICollectionInfo } from './ICollectionInfo';

export interface CollectionOwnerCache {
  readonly updateCollectionOwners: (collections: ICollectionInfo[]) => void;
}

export function initCollectionOwnerCache(): CollectionOwnerCache {

  const collectionOwners: _.Dictionary<IUser> = {};
  const updateStore = (collections: ICollectionInfo[]) => {
    const collectionUpdateOwnerData: UpdateOwnerData[] = collections.map((collection) => {
      return {
        contentId: collection.id,
        ownerId: collection.userId,
        contentType: collection.contentType
      };
    });
    appStore.dispatch(spaceContentsUpdateOwners(collectionOwners, collectionUpdateOwnerData));
  };

  return {
    updateCollectionOwners: (collections: ICollectionInfo[]) => {
      let userIds = collections.map((value) => value.userId);
      userIds = _.filter(userIds, (ownerId, idx) => {
        return userIds.indexOf(ownerId) === idx
        && !_.has(collectionOwners, ownerId);
      });

      if (userIds.length > 0) {
        const users = ServiceLocator.get<Users>('Users');
        users.getUsersById(userIds).then((usersResponse) => {
          usersResponse.items.forEach((user) => {
            collectionOwners[user.id] = user;
          });
          updateStore(collections);
        });
      } else {
        updateStore(collections);
      }
    }
  };
}

export const collectionOwnerCache = initCollectionOwnerCache();
